export default "__VITE_PUBLIC_ASSET__c4ce67bc__"